import React from 'react'

const ErrorView = ({ message }: { message: string }) => {
  return message ? <div> {message} </div> : null
}

export default ErrorView
